import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PiwikModule } from './shared/services/piwik';
import { ENVIRONMENT_CONFIG, LibConfig } from './shared/services/piwik/lib.config';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { CommonModule } from '@angular/common';
import { OidcInterceptor } from './core/interceptor/oidc.interceptor';

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule, CommonModule, AppRoutingModule, PiwikModule, HttpClientModule, SharedModule],
    providers: [
        { provide: ENVIRONMENT_CONFIG, useValue: environment },
        { provide: LibConfig, useValue: new LibConfig(environment) },
        { provide: HTTP_INTERCEPTORS, useClass: OidcInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
